import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FeatherIconsComponent} from "../../feather-icons/feather-icons.component";
import {RouterModule} from "@angular/router";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {AddComponent} from "../modals/add/add.component";
import {GeneralService} from "../../../../core/services/general.service";
import {NewEventComponent} from "../../../../features/service/event/new-event/new-event.component";
import {NewComponent} from "../../../../features/vehicles/category/new/new.component";

@Component({
  selector: 'app-header',
  standalone: true,
    imports: [
        RouterModule,
        FeatherIconsComponent,
        FormsModule,
        CommonModule
    ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit{
    @Output() action = new EventEmitter<any>();
    @Input() configuration: any;
    public isOpen : boolean = false;
    omiteBtnNew: string[] = ['Backlog', 'Cancelados', 'Servicios','Eventos cancelados', 'Hojas de Inspección'];
    columns: any[] = [];
    filter: any = {
        column:null,
        operator:null
    };
    filters: any[] = [];
    operators:any = [
        {id:"=", value: "igual"},
        {id:"LIKE", value: "Que contenga"},
        {id:">=", value: "Mayor o igual"},
        {id:"<=", value: "Menor o igual"},
    ];


    constructor(private modalService: NgbModal, private generalService: GeneralService) {
    }

    ngOnInit() {
        this.columns = this.configuration.columns.filter((item: any) => item.hasOwnProperty('id') && !item['onlyForm']);
    }

    //Función para agregar filtro
    addFilter(){
            // Validar si los tres parámetros están activos
        if (!this.filter.column || !this.filter.operator || !this.filter.value) {
            this.generalService.showMessage("warn",'Por favor, completa todos los filtros antes de continuar.');
            return;
        }
        // Crear el objeto filtro
        const newFilter = {
            column: this.filter.column,
            operator: this.filter.operator,
            value: this.filter.value
        };

        // Agregar el nuevo filtro al array de filtros
        this.filters.push(newFilter);

        // Limpiar el formulario después de agregar el filtro
        this.filter = {
            column: '',
            operator: '',
            value: ''
        };
    }

    // Método para eliminar un filtro específico
    removeFilter(index: number) {
        this.filters.splice(index, 1);
    }

    // Método auxiliar para obtener las claves del objeto filters
    objectKeys(obj: any): string[] {
        return Object.keys(obj);
    }

    //Función para abrir modal de Nuevo
    add(){
        if(this.configuration.title === "Evento") {
            this.newEvent();
        } else if(this.configuration.title === "Categoría") {
            this.newCategoryVehicle();
        }
        else {
            let modalAdd = this.modalService.open(AddComponent, {centered: true, windowClass: 'modal-xl'});
            modalAdd.componentInstance.title = "Nuevo " + this.configuration.title;
            modalAdd.componentInstance.columns = this.configuration.columns;
            modalAdd.componentInstance.data = {action: this.configuration.config};
            modalAdd.componentInstance.isNew = true;
            modalAdd.componentInstance.confirmAction = (data: any) => {
                if (this.action) {
                    this.action.emit(this.filters); // Ejecuta la función pasada
                }
            };
        }

    }

    newEvent(){
        let modal = this.modalService.open(NewEventComponent, { centered: true, size:'lg' });
        modal.componentInstance.data = '';
        modal.componentInstance.confirmAction = (data: any) => {
            if (this.action) {
                this.action.emit(this.filters); // Ejecuta la función pasada
            }
            modal.close();
        };
    }

    newCategoryVehicle(){
        let modal = this.modalService.open(NewComponent, { centered: true, size:'xl' });
        modal.componentInstance.data = '';
        modal.componentInstance.confirmAction = (data: any) => {
            if (this.action) {
                this.action.emit(this.filters); // Ejecuta la función pasada
            }
            modal.close();
        };
    }

    applyFilter(){
        if (this.action) {
            this.action.emit(this.filters); // Ejecuta la función pasada
        }

    }

    showHideFilter(){
        this.isOpen = !this.isOpen;
        if(!this.isOpen){
            this.filters = [];
            this.applyFilter();
        }
    }


    protected readonly Object = Object;
}
